import React, { useState } from "react"
import { manageInfoUpdate } from "../../../api/manage_info"
import { useNavigate } from "react-router-dom"
import { useLoading } from "../../LoadingContext"

import Card from "@mui/material/Card"
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import MDInput from "components/MDInput"
import MDButton from "components/MDButton"

interface ManageInfoProps {
  body: string
  onClose: (body: string | null) => void // モーダルを閉じるためのコールバック
}

const ManageInfo: React.FC<ManageInfoProps> = ({ body, onClose }) => {
  const { startLoading, stopLoading } = useLoading()
  const navigate = useNavigate()
  const [formData, setFormData] = useState({
    body: body
  })

  const [errors, setErrors] = useState({
    body: ""
  })

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const target = e.target as HTMLInputElement // 明示的に型キャスト
    const { name, value, type, checked } = target
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }))
  }

  const validate = () => {
    return true
  }

  const convertEnabledValues = (data: any) => {
    return data
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (validate()) {
      // バリデーション成功時の処理
      try {
        startLoading()
        const convertedData = convertEnabledValues(formData)
        await manageInfoUpdate(convertedData.body)
        onClose(formData.body)
      } catch (error: any) {
        if (error.response && error.response.status === 401) {
          navigate("/login") // セッション切れ時にトップページへリダイレクト
        } else if (error.response) {
          const errorDetail = error.response.data.detail
          const validationErrors = { ...errors }
          validationErrors.body = errorDetail.body
          setErrors(validationErrors)
        } else {
          const validationErrors = { ...errors }
          validationErrors.body = "サーバーへの接続に失敗しました"
          setErrors(validationErrors)
        }
      } finally {
        stopLoading()
      }
    }
  }

  return (
    <div className="modal-bg-cover">
      <Card
        sx={{
          width: "90%",
          maxWidth: "500px",
          maxHeight: "calc(100vh - 100px)",
          marginTop: "50px",
          marginBottom: "50px",
          paddingTop: "20px",
          paddingBottom: "20px",
          paddingLeft: "20px"
        }}
      >
        <button className="close-button" onClick={() => onClose(body)}>
          ×
        </button>
        <MDTypography variant="h4" fontWeight="medium">
          お知らせ変更
        </MDTypography>
        <MDBox style={{ height: "20px" }}></MDBox>
        <MDBox
          style={{
            maxHeight: "calc(100vh - 200px)",
            overflowY: "auto",
            paddingTop: "10px",
            paddingLeft: "5px",
            paddingRight: "25px"
          }}
        >
          <MDBox display="flex" alignItems="center" gap={1}>
            <MDInput
              label="お知らせ"
              type="text"
              name="body"
              value={formData.body}
              onChange={(e) => handleChange(e)}
              multiline
              minRows={4} // これで高さを固定しつつ、可変できる
              sx={{ width: "100%" }}
            />
          </MDBox>
          {errors.body && (
            <MDBox
              color="#FF0000" // テキスト色
              pl={2} // 左パディング
              mb={2} // 下マージン
              fontSize="0.7em" // フォントサイズ
            >
              {errors.body}
            </MDBox>
          )}
          <MDBox mt={4} mb={2}>
            <MDButton
              variant="contained"
              color="info"
              fullWidth
              sx={{
                borderRadius: "4px",
                textTransform: "none",
                fontSize: "1rem",
                padding: "0.75rem 0",
                backgroundColor: "#1976d2",
                "&:hover": {
                  backgroundColor: "#1565c0"
                }
              }}
              onClick={(e) => {
                handleSubmit(e)
              }}
            >
              更新
            </MDButton>
          </MDBox>
        </MDBox>
      </Card>
    </div>
  )
}

export default ManageInfo
